import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { Typography, withStyles } from '@material-ui/core';
import { hasPermission, parseURL } from '../../sc-utilities';
import ProductOverviewList from './ProductOverviewList';
import { indexStyle, getModel , imeisAndSerialNumber} from './utils';

const styles = theme => (indexStyle);

const ProductsMinimal = props => {
    const { classes, productTypeLookup, translations, permissions, currentView, updateView, method, createPaletteActionForProduct, createAction, tableRef, redirectOptions, groupsLookup } = props;

    let searchParams = parseURL(window.location.search);

    let tableColumns = useMemo(() => {
        const columns = tableRef?.current?.state?.columns ?? [];

        const filter = (value) => {
            if (columns) {
                let index = columns.findIndex(column => column.field === value);
                if (index !== -1) {
                    return columns[index];
                }
            }
        };

        const groupsDefaultFilter = () => {
            if (searchParams && searchParams.GroupID) {
                return [searchParams.GroupID];
            } else if (filter('GroupID')?.tableData?.filterValue.length>0) {
                return filter('GroupID')?.tableData?.filterValue;
            }
            return Object.keys(groupsLookup);
        }

        return [
            {
                title: translations["action"] || 'Action', field: 'Action', filtering: false, cellStyle: { minWidth: 150, maxWidth: 150 },
                hidden: filter('Action')?.hidden,
                columnOrder: filter('Action')?.tableData?.columnOrder,
                sorting: false,
                export: false,
                render: rowData => {
                    return createAction(rowData.Type, rowData.ProductID, rowData?.CustomerID || null, rowData?.Customer?.Name || 'n/a', rowData.DeviceOnlineStatuses instanceof Array && rowData.DeviceOnlineStatuses.length > 0 ? rowData.DeviceOnlineStatuses[0] : {})
                }
            },
            {
                title: translations["vendor"] || 'Vendor', field: 'Vendor',
                hidden: filter('Vendor')?.hidden ?? false,
                columnOrder: filter('Vendor')?.tableData?.columnOrder,
                defaultFilter: filter('Vendor')?.tableData?.filterValue,
                defaultSort: filter('Vendor')?.tableData?.columnOrder === tableRef?.current?.state?.orderBy ? tableRef?.current?.state?.orderDirection : undefined,
                render: rowData => {
                    return <Typography key={rowData.ProductID} style={{ fontSize: 12 }}
                        gutterBottom>{rowData.Vendor}</Typography>
                }
            },
            {
                title: translations["inventory_number"] || 'Inventory Number', field: 'InventoryNumber',
                hidden: filter('InventoryNumber')?.hidden ?? false,
                columnOrder: filter('InventoryNumber')?.tableData?.columnOrder,
                defaultFilter: filter('InventoryNumber')?.tableData?.filterValue,
                defaultSort: filter('InventoryNumber')?.tableData?.columnOrder === tableRef?.current?.state?.orderBy ? tableRef?.current?.state?.orderDirection : undefined,
                render: rowData => {
                    return <Typography key={rowData.ProductID} style={{ fontSize: 12 }}
                        gutterBottom>{rowData.InventoryNumber ?? 'n/a'}</Typography>
                }
            },
            {
                title: translations["inventory_id"] || 'Securaze ID', field: 'InventoryID',
                hidden: filter('InventoryID')?.hidden ?? false,
                columnOrder: filter('InventoryID')?.tableData?.columnOrder,
                defaultFilter: filter('InventoryID')?.tableData?.filterValue,
                defaultSort: filter('InventoryID')?.tableData?.columnOrder === tableRef?.current?.state?.orderBy ? tableRef?.current?.state?.orderDirection : undefined,
                render: rowData => {
                    return rowData.InventoryID ? createPaletteActionForProduct(rowData.InventoryID, rowData.Type, classes, rowData?.CustomerID || null, rowData?.Customer?.Name || 'n/a') : 'n/a'
                }
            },
            {
                title: translations["serial_imei"] || 'Serial Number / IMEI', field: 'SerialNumber', cellStyle: { minWidth: 250, maxWidth: 250 },
                hidden: filter('SerialNumber')?.hidden ?? false,
                columnOrder: filter('SerialNumber')?.tableData?.columnOrder,
                defaultFilter: filter('SerialNumber')?.tableData?.filterValue,
                defaultSort: filter('SerialNumber')?.tableData?.columnOrder === tableRef?.current?.state?.orderBy ? tableRef?.current?.state?.orderDirection : undefined,
                render: rowData => {
                    return imeisAndSerialNumber(rowData, translations);
                }
            },
            {
                title: translations["model"] || 'Model', field: 'Model', cellStyle: { minWidth: 250, maxWidth: 250 },
                hidden: filter('Model')?.hidden ?? false,
                columnOrder: filter('Model')?.tableData?.columnOrder,
                defaultFilter: filter('Model')?.tableData?.filterValue,
                defaultSort: filter('Model')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? tableRef?.current?.state?.orderDirection : undefined,
                render: rowData => {
                    return <Typography key={`${rowData.ProductID}_model`} style={{ fontSize: 12 }}
                        gutterBottom>{getModel(rowData)}</Typography>
                }
            },
            {
                title: translations["type"] || 'Type', field: 'ProductType',
                hidden: filter('ProductType')?.hidden ?? false,
                columnOrder: filter('ProductType')?.tableData?.columnOrder,
                lookup: productTypeLookup,
                defaultFilter: filter('ProductType')?.tableData?.filterValue,
                defaultSort: filter('ProductType')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? tableRef?.current?.state?.orderDirection : undefined,
                render: rowData => {
                    return <Typography key={`${rowData.ProductID}_type`} style={{ fontSize: 12 }}
                        gutterBottom>{rowData?.Type}</Typography>
                }
            },
            {
                title: translations["group"] || 'Group', field: 'GroupID',
                cellStyle: { minWidth: 100, maxWidth: 100 },
                hidden: filter('GroupID')?.hidden ?? false,
                columnOrder: filter('GroupID')?.tableData?.columnOrder,
                defaultFilter: groupsDefaultFilter(),
                lookup: groupsLookup,
                defaultSort: filter('GroupID')?.tableData?.columnOrder === tableRef?.current?.dataManager?.orderBy ? tableRef?.current?.state?.orderDirection : undefined,
                render: rowData => {
                    return <Typography key={rowData?.Group?.Name} style={{ fontSize: 12 }} gutterBottom>{rowData?.Group?.Name ?? (translations['short_not_assigned'] || 'n/a')}</Typography>
            }}
        ].sort((a, b) => a.columnOrder - b.columnOrder);
    }, [classes, createAction, productTypeLookup, createPaletteActionForProduct, tableRef, translations, searchParams, groupsLookup]);

    tableColumns = hasPermission(permissions, 'group_list')? tableColumns : tableColumns.filter((column) => column.field!=="GroupID");

    return (
        <div >
            {hasPermission(permissions, 'all_assets_view') ?
                <ProductOverviewList groupsLookup={groupsLookup} currentView={currentView} updateView={updateView} tableColumns={tableColumns} tableRef={tableRef} method={method} redirectOptions={redirectOptions} />
                : null}
        </div >
    );
}

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        translations: state?.translate?.translations?.activeTranslations || {}
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(ProductsMinimal));